import {Injectable} from "@angular/core";
import {Versao} from "../../../domain/Versao";
import {AbstractSQLService} from "./AbstractSQLService";

@Injectable()
export class VersaoSQLService extends AbstractSQLService<Versao>{
    nomeTabela = "versao"
  agenciavel = false

    async findByNome(nome: string) : Promise<Versao | undefined> {
        const col = await this.db.query('select * from versao where nome=?',[nome])
        return  col.values == undefined || col.values.length == 0 ? undefined : col.values[0] as Versao
    }

}
